import { Vector3 } from 'three';
import type { Punch } from '../rules/punch';

/**
 * Where one hand's punch really got to: it may have stopped on what it met short of where it aimed. Once stopped it
 * stays stopped, however the other moves after, and on its way back it comes from where it was, not where it aimed.
 */
export class Landing {
  /** Where the wrist was, in whatever space the arm is placed in. */
  readonly at = new Vector3();
  private punch: Punch | null = null;
  private stopped = false;
  private landed = false;

  /** Every frame, with the hand's punch: a new one starts afresh. */
  follow(punch: Punch): void {
    if (punch === this.punch) return;
    this.punch = punch;
    this.stopped = this.landed = false;
  }

  /** True while the glove belongs where the punch got to, rather than on its way to where it aims. */
  get holds(): boolean {
    const phase = this.punch?.phase;
    return (phase === 'active' && this.stopped) || (phase === 'recovery' && this.landed);
  }

  /** The glove stopped on something, its wrist here. */
  stop(wrist: Vector3): void {
    this.at.copy(wrist);
    this.stopped = this.landed = true;
  }

  /** Where the wrist is this frame: kept while the punch is on its target, unless it stopped short. */
  reach(wrist: Vector3): void {
    if (this.punch?.phase !== 'active' || this.stopped) return;
    this.at.copy(wrist);
    this.landed = true;
  }
}
